<template>
    <div id="totalMonthStats">
        <b-alert variant="info" v-if="Object.keys(yearMonths).length === 0">
            No data available yet. Make a move.
        </b-alert>
        <b-tabs v-else>
            <b-tab :title="year" active v-for="year in Object.keys(yearMonths)" :key="year">
                <div class="table-responsive-sm">
                    <table class="table table-sm table-bordered table-hover">
                        <thead>
                        <tr>
                            <th>Month</th>
                            <th class="text-right">Invested</th>
                            <th class="text-right">Total value</th>
                            <th class="text-right">Profit</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="i in 12" >
                            <td><h4>{{dateTexts.months[i - 1]}}</h4></td>
                            <td class="text-right">
                                <p v-if="year >= currentDate.year() && (i - 1) > currentDate.month()">---</p>
                                <p v-else-if="yearMonthValue(year, i) !== undefined">
                                    <b>{{yearMonthTotalValue(year, i).toFixed(2)}}</b>
                                    <br>
                                    <small>{{yearMonthValue(year, i).toFixed(2)}}</small>
                                </p>
                                <p v-else>---</p>
                            </td>
                            <td class="text-right">
                                <p v-if="year >= currentDate.year() && (i - 1) > currentDate.month()">---</p>
                                <p v-else-if="yearMonthLastPrice(year, i) !== undefined">
                                    <b>{{yearMonthLastPrice(year, i).toFixed(2)}}</b>
                                </p>
                                <p v-else>---</p>
                            </td>
                            <td v-if="year >= currentDate.year() && (i - 1) > currentDate.month()" class="text-right">
                                <p>---</p>
                            </td>
                            <td v-else class="text-right bold"
                                :class="yearMonthProfitPercentage(year, i) > 0 ? 'bg-success text-white' : (yearMonthProfitPercentage(year, i) < 0 ? 'bg-danger text-white' : '')">
                                <p v-if="yearMonthLastPrice(year, i) !== undefined && yearMonthValue(year, i) !== undefined">
                                    {{yearMonthProfitPercentage(year, i)}}%<br>
                                    <small>({{(yearMonthLastPrice(year, i) - yearMonthTotalValue(year,
                                        i)).toFixed(2)}})</small>
                                </p>
                                <p v-else-if="yearMonths[year].hasOwnProperty(i) && yearMonths[year][i].hasOwnProperty('lastUpdatePrice')">
                                    100% <small>({{yearMonths[year][i].lastUpdatePrice}})</small>
                                </p>
                                <p v-else>---</p>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

            </b-tab>

        </b-tabs>
    </div>
</template>

<script>

    import dayjs from "dayjs"
    import dateTexts from "../../data/dateTexts"

    export default {
        name: "monthStats",
        props: ['portfolios'],
        data: () => {
            return {
                yearMonths: {},
                currentDate: dayjs()
            }
        },
        watch: {
            portfolios() {
                this.updateYearMonths();
            }
        },
        mounted() {
            this.updateYearMonths();
        },
        computed: {
            dateTexts: function () {
                return dateTexts
            }
        },
        methods: {
            updateYearMonths() {
                const dates = {};
                if (this.portfolios) {

                    let minYear = 9999;
                    this.portfolios.forEach(p => {
                        p.moves.forEach(m => {
                            minYear = (dayjs(m.date).year() < minYear) ? dayjs(m.date).year() : minYear;
                        });
                    });

                    for (let year = minYear; year <= dayjs().year(); year++) {

                        dates[year] = {};
                        for (let i = 0; i < 12; i++) {
                            const maxDate = dayjs(`${year}-${i > 9 ? (i + 1) : ('0' + (i + 1))}-31 23:59:59`);
                            const minDate = dayjs(`${year}-${i > 9 ? (i + 1) : ('0' + (i + 1))}-01 00:00:01`);
                            dates[year][i] = {
                                totalValue: 0,
                                moveValue: 0,
                                lastUpdatePrice: {},
                                maxDate: minDate
                            };

                            this.portfolios.forEach(portfolio => {
                                dates[year][i].lastUpdatePrice[portfolio.id] = 0;
                                dates[year][i].maxDate[portfolio.id] = minDate;
                                portfolio.moves.filter(m => dayjs(m.date) <= maxDate && dayjs(m.date) >= minDate).forEach(move => {
                                    const date = dayjs(move.date);
                                    dates[year][i].moveValue += Number(move.price)
                                });
                                portfolio.moves.filter(m => dayjs(m.date) <= maxDate).forEach(move => {
                                    const date = dayjs(move.date);
                                    dates[year][i].totalValue += Number(move.price)
                                });

                                portfolio.priceUpdates.filter(m => dayjs(m.date) <= maxDate).forEach(move => {
                                    const date = dayjs(move.date);
                                    if (date > dates[year][i].maxDate[portfolio.id]) {
                                        dates[year][i].lastUpdatePrice[portfolio.id] = Number(move.price);
                                        dates[year][i].maxDate[portfolio.id] = date
                                    }
                                });

                            });



                        }

                    }

                    Object.keys(dates).forEach(year => {
                        Object.keys(dates[year]).forEach(month => {
                            Object.keys(dates[year][month].lastUpdatePrice).forEach(portfolioId => {
                                if (dates[year][month].lastUpdatePrice[portfolioId] === 0) {
                                    // console.log('Upravujem datum ' + year + ' ' + month);
                                    for (let y = year; y > 1950; y--) {
                                        for (let m = (month - 1); m > 0; m--) {
                                            if (dates.hasOwnProperty(y) && dates[y].hasOwnProperty(m) && dates[y][m].lastUpdatePrice.hasOwnProperty(portfolioId) &&  dates[y][m].lastUpdatePrice[portfolioId] !== 0) {
                                                // console.log('do datumu ' +year + ' ' + month + ' sa vlozi hodnota z ' + y + ' ' + m + ": " + dates[y][m].lastUpdatePrice);
                                                dates[year][month].lastUpdatePrice[portfolioId] = dates[y][m].lastUpdatePrice[portfolioId];
                                                break;
                                            }
                                        }
                                    }
                                }
                            });

                        });
                    });

                    Object.keys(dates).forEach(year => {
                        Object.keys(dates[year]).forEach(month => {
                            const vals = Object.keys(dates[year][month].lastUpdatePrice).map(k => dates[year][month].lastUpdatePrice[k]);
                            dates[year][month].lastUpdatePrice = vals.length > 0 ? vals.reduce((total,v) => total + v) : 0;
                            // console.log(year + ' ' + month + ": " + dates[year][month].lastUpdatePrice);
                        });
                    });

                    Object.keys(dates).forEach(year => {
                        Object.keys(dates[year]).forEach(month => {
                            if (dates[year][month].lastUpdatePrice === 0) {
                                // console.log('Upravujem datum ' + year + ' ' + month);
                                for (let y = year; y > 1950; y--) {
                                    for (let m = (month - 1); m > 0; m--) {
                                        if (dates.hasOwnProperty(y) && dates[y].hasOwnProperty(m) && dates[y][m].lastUpdatePrice !== 0) {
                                            // console.log('do datumu ' +year + ' ' + month + ' sa vlozi hodnota z ' + y + ' ' + m + ": " + dates[y][m].lastUpdatePrice);
                                            dates[year][month].lastUpdatePrice = dates[y][m].lastUpdatePrice;
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                    })

                }
                this.yearMonths = dates;
            },
            yearMonthValue(year, month) {
                const m = month - 1;
                return this.yearMonths[year].hasOwnProperty(m) && this.yearMonths[year][m].hasOwnProperty('moveValue') ? this.yearMonths[year][m].moveValue : undefined;
            },
            yearMonthTotalValue(year, month) {
                const m = month - 1;
                return this.yearMonths[year].hasOwnProperty(m) && this.yearMonths[year][m].hasOwnProperty('totalValue') ? this.yearMonths[year][m].totalValue : undefined;
            },
            yearMonthLastPrice(year, month) {
                const m = month - 1;
                return this.yearMonths[year].hasOwnProperty(m) && this.yearMonths[year][m].hasOwnProperty('lastUpdatePrice') ? this.yearMonths[year][m].lastUpdatePrice : undefined;
            },
            yearMonthProfitPercentage(year, month) {
                if (this.yearMonthLastPrice(year, month) !== undefined && this.yearMonthTotalValue(year, month) !== undefined) {
                    const num = (((this.yearMonthLastPrice(year, month) - this.yearMonthTotalValue(year, month)) * 100) / this.yearMonthTotalValue(year, month));
                    return !isNaN(num) ? num.toFixed(0) : 0;
                } else if (this.yearMonthLastPrice(year, month) !== undefined) {
                    return 100;
                } else {
                    return 0;
                }
            }
        }
    }
</script>
